import Dialog from '@/components/Dialog';
import { FormControl } from '@mui/material';
import SectionTitle from './SectionTitle';
import RowAttachmentTypeOptions from './RowAttachmentTypeOptions';
import styled from '@emotion/styled';
import React from 'react';

type ChallengeRowAttachmentProps = {
  children: React.ReactNode;
};

const StyledDialogContent = styled(Dialog.Content)({
  paddingTop: 0,
  overflowY: 'visible',
});

const ChallengeRowAttachment = ({ children }: ChallengeRowAttachmentProps) => (
  <StyledDialogContent>
    <FormControl fullWidth>{children}</FormControl>
  </StyledDialogContent>
);

ChallengeRowAttachment.Title = SectionTitle;
ChallengeRowAttachment.TypeOptions = RowAttachmentTypeOptions;

export default ChallengeRowAttachment;
